<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("btn.qualityPlan.result") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <!-- <li class="breadcrumb-itemSelect"><router-link to="/prd"><span>{{$t('btn.qualityPlan.result')}}</span></router-link></li> -->
          <li class="breadcrumb-item">
            <router-link to="/prd/qualityPlan">
              <span>{{$t('tlt.qualityPlan')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/qualityResult">
              <span>{{$t('tlt.qualityData.result')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/qualityResult/display">
              <span>{{$t('tlt.qualityResult.diplay')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <section class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-2">
                  <label class="control-label">选择检验项目</label>
                  <dimsearch
                    name=" ItemCode"
                    v-model="itemSelect"
                    :entity="qualityItems"
                    bindId="itemSelect"
                    bindProp="itemName"
                    submitProp="itemCode"
                  ></dimsearch>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">选择炉号:</label>
                  <select class="form-control" v-model="furnaceSelect">
                    <option value>全部</option>
                    <option value="1">{{$t('opt.furnaceNumber1')}}</option>
                    <option value="2">{{$t('opt.furnaceNumber2')}}</option>
                    <option value="3">{{$t('opt.furnaceNumber3')}}</option>
                    <option value="4">{{$t('opt.furnaceNumber4')}}</option>
                    <option value="5">{{$t('opt.furnaceNumber5')}}</option>
                    <option value="6">{{$t('opt.furnaceNumber6')}}</option>
                  </select>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">请选择时间区间:</label>
                  <select class="form-control" v-model="timeSelect">
                    <option value="year">年</option>
                    <option value="month">月</option>
                    <option value="week">周</option>
                    <option value="other">自定义</option>
                  </select>
                </div>
                <div v-if="timeSelect=='other'" class="form-group col-md-2">
                  <label class="control-label" v-if="timeSelect=='other'">开始:</label>
                  <mmf-datepicker v-if="timeSelect=='other'" v-model="startTime"></mmf-datepicker>
                </div>
                <div v-if="timeSelect=='other'" class="form-group col-md-2">
                  <label class="control-label" v-if="timeSelect=='other'">结束:</label>
                  <mmf-datepicker v-if="timeSelect=='other'" v-model="endTime"></mmf-datepicker>
                </div>
                <div class="col-lg-12 align-self-end">
                  <div class="float-lg-right">
                    <button
                      class="btn btn-outline-secondary mr-1"
                      type="button"
                      v-on:click="clearFilter()"
                    >
                      <i class="fa fa-fw fa-lg fa-eraser"></i>
                      <span class="text">{{ $t("btn.basic.clear") }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="qualityResultTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="form-group col-md-2">
                <el-radio v-model="type" label="type1" value="type1">元素趋势</el-radio>
                <el-radio v-model="type" label="type2" value="type2">元素占比</el-radio>
              </div>
              <div id="container" style="height:800px;width: auto;"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MmfDatepicker from "@/components/MmfDatepicker";
import dimsearch from "@/components/MMFDimSearch";
export default {
  name: "qualityDataList",
  data() {
    return {
      type: "type1",
      timeSelect: "",
      xAxis: [],
      series: [],
      startTime: "",
      endTime: "",
      itemSelect: "",
      furnaceSelect: "",
      legend: "",
      pieValue: [],
      resultFilter: {}
    };
  },
  components: {
    MmfDatepicker,
    dimsearch
  },
  methods: {
    ...mapActions("qualityResult", ["getResults", "getQualityItemDetails","display"]),
    drawChart() {
      var me = this;
      var myChart = this.$echarts.init(document.getElementById("container"));
      var app = {};
      var option1 = null;
      var option2 = null;
      option1 = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: this.legend,
          selectedMode: "single"
        },
        grid: {
          top: "50px",
          left: "100px",
          right: "100px",
          bottom: "100px"
        },
        toolbox: {
          feature: {
            magicType: { show: true, type: ["line", "bar"] },
            saveAsImage: {},
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.results
            .filter(x => x.parameterName == this.legend[0])
            .map(y => {
              return y.checkTime;
            })
          // axisLabel: {
          //   interval: 0,
          //   formatter: function(value) {
          //     //x轴的文字改为竖版显示
          //     var str = value.split("");
          //     return str.join("\n");
          //   }
          // }
        },
        yAxis: {
          type: "value"
        },
        series: this.series
      };
      option2 = {
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        series: [
          {
            name: "元素占比",
            type: "pie",
            radius: "55%",
            center: ["50%", "50%"],
            data: this.pieValue,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };
      if (this.type == "type1") {
        if (option1 && typeof option1 === "object") {
          myChart.setOption(option1, true);
        }
      }
      if (this.type == "type2") {
        if (option2 && typeof option2 === "object") {
          myChart.setOption(option2, true);
        }
      }

      myChart.on("legendselectchanged", function(obj) {
        var name = obj.name;
        var option = myChart.getOption();
        option.xAxis[0].data = me.results
          .filter(y => y.parameterName == name)
          .map(x => {
            return x.checkTime;
          });
        myChart.setOption(option, true);
      });
    },

    setPieValue() {
     
      this.pieValue = this.qualityItemDetails.map(obj => {
        return {
          value: this.sum(
            this.results
              .filter(x => x.parameterName == obj.parameterName)
              .map(y => {
                return y.checkValue;
              })
          ),
          name: obj.parameterName
        };
      });
    },
    sum(arr) {
      var s = 0;
      arr.forEach(function(val, idx, arr) {
        s += val;
      }, 0);

      return s;
    },
    setSeries() {
      
      //过滤数据
      var me = this;
      this.series = this.qualityItemDetails.map(function(obj) {
        return {
          name: obj.parameterName,
          type: "line",
          stack: "总量",
          barWidth: "55px",
          markLine: {
            data: [
              {
                name: "上限",
                yAxis: obj.measureUp,
                lineStyle: {
                  color: "#008B00",
                  width: 2
                }
              },
              {
                name: "下限",
                yAxis: obj.measureDown,
                lineStyle: {
                  color: "#DC143C",
                  width: 2
                }
              }
            ]
          },
          data: me.results
            .filter(x => {
              return x.parameterName == obj.parameterName;
            })
            .map(y => {
              return y.checkValue;
            })
        };
      });
    },

    getStartDay() {
      switch (this.timeSelect) {
        case "year": {
          var now = new Date();
          var curYear = now.getFullYear();
          return this.getFormatDate(new Date(curYear, 0, 1));
        }
        case "month": {
          var date = new Date();
          date.setDate(1);
          var month = parseInt(date.getMonth() + 1);
          var day = date.getDate();
          if (month < 10) {
            month = "0" + month;
          }
          if (day < 10) {
            day = "0" + day;
          }
          return this.getFormatDate(
            new Date(date.getFullYear(), month - 1, day, 0, 0, 0)
          );
        }
        case "week": {
          var now = new Date(); //当前日期
          var nowDayOfWeek = now.getDay(); //今天本周的第几天
          var nowDay = now.getDate(); //当前日
          var nowMonth = now.getMonth(); //当前月
          var nowYear = now.getFullYear(); //当前年
          if (nowDay == 0) {
            return this.getFormatDate(new Date(nowYear, nowMonth, nowDay - 6));
          }
          return this.getFormatDate(
            new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1)
          );
        }
      }
    },
    getFormatDate(date) {
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentDate = date.getFullYear() + "-" + month + "-" + strDate;
      return currentDate;
    },
    setLegend() {
      this.legend = this.qualityItemDetails.map(x => {
        return x.parameterName;
      });
    },
 
    clearFilter() {
      this.timeSelect = "";
      this.furnaceSelect = "";
      this.itemSelect = "";
      this.startTime = "";
      this.endTime = "";
      this.results = [];
      this.setSeries();
      this.drawChart();
    },
    getQualityResults() {
      if (this.itemSelect != "" && this.timeSelect != "") {
        this.resultFilter.itemCodeFilter = this.itemSelect;
        if (this.timeSelect == "other") {
          this.resultFilter.startTimeFilter = this.startTime;
          this.resultFilter.endTimeFilter = this.endTime;
        } else {
          this.resultFilter.startTimeFilter = this.getStartDay();
          this.resultFilter.endTimeFilter = this.getFormatDate(new Date());
        }
        if (this.furnaceSelect != "") {
          this.resultFilter.furnaceNameFilter = this.furnaceSelect;
        }

        this.getResults(this.resultFilter);
      }
    }
  },

  computed: {
    ...mapState({
      qualityItems: state => state.qualityItem.rows,
      results: state =>
        state.qualityResult.results.sort(function(a, b) {
          return a.checkTime > b.checkTime ? 1 : -1;
        }),
      qualityItemDetails: state => state.qualityResult.qualityItemDetails
    })
  },

  watch: {
    timeSelect: {
      handler(val) {
        if (val != "" && val != "other" && this.itemSelect != "") {
          this.getQualityResults();
        }
      }
    },
    furnaceSelect: {
      handler(val) {
        if (val != "" && this.itemSelect != "" && this.timeSelect != "") {
          this.getQualityResults();
        }
      }
    },
    startTime: {
      handler(val) {
        if (
          this.startTime.length ==10 &&
          this.endTime.length ==10 &&
          this.itemSelect != ""
        ) {
          this.getQualityResults();
        }
      }
    },
    endTime: {
      handler(val) {
        
        if (
          this.startTime.length ==10 &&
          this.endTime.length ==10 &&
          this.itemSelect != ""
        ) {
          this.getQualityResults();
        }
      }
    },
    itemSelect: {
      handler(val) {
        if (val != "") {
          this.getQualityItemDetails(val);
        }
      }
    },

    qualityItemDetails: {
      handler(val) {
        this.setLegend();
        this.setSeries();
        this.drawChart();
        this.getQualityResults();
      }
    },
    results: {
      handler(val) {
        
        this.setPieValue();
        this.setSeries();
        this.drawChart();
      }
    },
    type: {
      handler(val) {
        
          this.drawChart();
        
      }
    }
  },
  created(){
    this.display();
  }
};
</script>
